import type { FC } from "react";

import { LoginModalView, useActiveLoginModalContext } from "@/src/contexts";
import TelemetryButtonV2 from "@Components/Button/TelemetryButton/TelemetryButtonV2";
import { CashbackEventType, type PropsTelemetryCustom, TelemetryEntity } from "@Components/Modules/Helpers";
import Text from "@Components/Text";
import TelemetryHoc from "@Components/telemetry-hoc/telemetry-hoc";
import * as stylex from "@stylexjs/stylex";

import { type QuerySmMax, type QueryXsMax, colors } from "../../../styles/tokens.stylex";

export interface ISecondRegistrationBanner extends PropsTelemetryCustom {
    title: string;
    registerBtnText: string;
}

export const SecondRegistrationBanner: FC<ISecondRegistrationBanner> = ({
    title,
    registerBtnText,
    telemetryCustom,
}) => {
    const { setActiveLoginModal } = useActiveLoginModalContext();

    const openRegistration = () => setActiveLoginModal(LoginModalView.Registration);

    return (
        <TelemetryHoc telemetryCustom={telemetryCustom} styleX={styles.secondRegistrationBannerComponent}>
            <Text
                textElement="h2"
                fontStyle="h1"
                dangerouslySetInnerHTML={{ __html: title }}
                styleX={styles.title}
            />

            <TelemetryButtonV2
                variant="magentaBackground"
                onClick={openRegistration}
                styleX={styles.regBtn}
                telemetryCustom={{
                    eventName: `${TelemetryEntity.Cashback}-${CashbackEventType.BottomBannerRegister}`,
                    actionType: "Click",
                }}
            >
                {registerBtnText}
            </TelemetryButtonV2>
        </TelemetryHoc>
    );
};

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    secondRegistrationBannerComponent: {
        padding: { default: "80px 0", [xsMax]: "40px 0" },
        backgroundPosition: "0% 0%",
        backgroundColor: "transparent",
        backgroundImage: `linear-gradient(19deg, ${colors.bg_BrandPrimary} 0%, ${colors.b_BrandMagenta} 100%, #000 100%)`,
        backgroundOrigin: "padding-box",
        backgroundRepeat: "no-repeat",
        textAlign: "center",
        width: "100%",
    },

    title: {
        padding: { default: "0 15%", [smMax]: 0 },
        color: colors.b_Emphasis,
    },

    regBtn: {
        marginTop: "30px",
    },
});
